import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import { TextV2 } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import OrgIcon from 'components/Svgs/icons/Organisation';
import { OrganisationResponse } from 'api';
import LinkButton from 'components/LinkButton';
import ChangeOrgDialog from './ChangeOrgDialog';

type OrganisationPickerProps = {
  disabled: boolean;
  organisation: OrganisationResponse | null;
  handleOrganisationChange: (value: OrganisationResponse | null) => void;
  hasAllOrgsOption?: boolean;
  open?: boolean;
  handleOnClose?: () => void;
};

const StyledOrgIcon = styled(OrgIcon)(({ theme }) => ({
  display: 'block',
  width: theme.spacing(spacingSizeMap.L),
  height: theme.spacing(spacingSizeMap.L),
  marginRight: '12px',
  padding: '5px 4px',
  backgroundColor: theme.palette.grey[100],
  border: `1px solid ${theme.palette.grey[400]}`,
  borderRadius: '5px',
  fill: theme.palette.grey[500],
}));

const ChangeOrganisation = ({
  disabled,
  organisation,
  handleOrganisationChange,
  handleOnClose = () => {},
  hasAllOrgsOption = true,
  open = false,
}: OrganisationPickerProps) => {
  const { t } = useTranslation();

  const [changingOrg, setChangingOrg] = useState(false);

  return (
    <>
      <Grid
        container
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid>
          <Grid
            container
            sx={[
              {
                alignItems: 'center',
              },
              (theme) => ({
                padding: '4px 16px 4px 10px',
                backgroundColor: theme.palette.grey[100],
                border: `1px solid ${theme.palette.grey[500]}`,
                borderRadius: '5px',
              }),
            ]}
          >
            <Grid>
              <StyledOrgIcon />
            </Grid>
            <Grid>
              <TextV2 data-testid="filtered-organisation" variant="bodyBold">
                {organisation?.name ||
                  t(
                    'ui.event-management.learners.organisation.change-org.all-organisations',
                  )}
              </TextV2>
            </Grid>
          </Grid>
        </Grid>
        {!disabled && (
          <LinkButton onClick={() => setChangingOrg(true)}>
            {t('ui.event-management.learners.organisation.change')}
          </LinkButton>
        )}
      </Grid>
      <ChangeOrgDialog
        open={changingOrg || open}
        onClose={() => {
          setChangingOrg(false);
          handleOnClose();
        }}
        selectedOrg={organisation ?? undefined}
        handleOrganisationChange={handleOrganisationChange}
        hasAllOrgsOption={hasAllOrgsOption}
      />
    </>
  );
};
export default ChangeOrganisation;
